// редюсер для окружения магазина
import apiClass from "./init";
const api = new apiClass();


export default api;
